<template lang="pug">
form.panel(@submit.prevent="submit")
  .panel-header #[.panel-title.h5 {{ grauInfracao ? 'Editar' : 'Adicionar' }} grau de infração]
  .panel-body
    .columns
      .column
        form-group(label="Descrição do grau de infração" :validation="$v.resource.descricao")
          input.form-input(v-model="$v.resource.descricao.$model" v-autofocus)
      .column.col-auto
        form-group(label="Valor" :validation="$v.resource.valor")
          money.form-input(v-model="$v.resource.valor.$model")
  .panel-footer.text-right
    a.btn.btn-link(@click="$emit('cancel')")
      btn-content(name="cancel")
    button.btn.btn-primary(:disabled="$v.resource.$invalid")
      btn-content(name="confirm")
</template>

<script>
import DocCalculoGrauInfracao from '@/models/DocCalculoGrauInfracao'
import { required, maxLength, minValue } from 'vuelidate/lib/validators'

export default {
  data() {
    return {
      resource: new DocCalculoGrauInfracao(this.grauInfracao),
    }
  },
  props: { grauInfracao: { type: Object, default: () => ({}) } },
  validations: {
    resource: {
      codigo: { required },
      descricao: { required, maxLength: maxLength(255) },
      valor: { required, minValue: minValue(0.01) },
    },
  },
  methods: {
    submit() {
      this.$emit('submit', { resource: this.resource })
    },
  },
}
</script>
